module.exports = "<navbar logo=\"Material UI Vue\"> <nav-item><a href=#>Vue<badge new>102</badge></a></nav-item> <nav-item><a href=#>React</a></nav-item> </navbar>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/badges/badges-in-navbar.vue
 ** module id = 135
 ** module chunks = 0
 **/